import { render, staticRenderFns } from "./ExpansionPanels.vue?vue&type=template&id=42fe01a3&scoped=true"
import script from "./ExpansionPanels.vue?vue&type=script&lang=js"
export * from "./ExpansionPanels.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanels.vue?vue&type=style&index=0&id=42fe01a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe01a3",
  null
  
)

export default component.exports